<div class="heading">
    <p>Archive Prompt</p>
   
</div>
<div class="instruction">
    <p class="mb-32">Are you sure you want to archive <span style="font-weight: 700; word-break: break-word;">"{{data?.prompt_name}}"</span> prompt?</p>
    <p class="mb-32">It will no longer be available for user but can be restored if needed.</p>
</div>
<div class="btn-container">
    <app-button [type]="'secondary'" [buttonType]="'button'" [buttonText]="'Cancel'" class="w-50 mr-12" (click)="cancelArchive()"></app-button>
    <app-button [type]="'primary'" [buttonType]="'button'" [buttonText]="'Archive'" class="w-50" (click)="archivePrompt()"></app-button>
</div>